








































import { Component } from 'vue-property-decorator'
import { AbstractModuleForm } from '../../abstract/form'
import { IframeModule, IframeModuleContent, IframeModuleContentInput } from '../Iframe.contracts'
import { iframeContentFactory } from '../Iframe.factory'

@Component<IframeModuleForm>({
  name: 'IframeModuleForm'
})
export class IframeModuleForm extends AbstractModuleForm<IframeModuleContentInput, IframeModule> {
  public initialContent: IframeModuleContent = iframeContentFactory()

  public extractSrc (): void {
    const matches = /<iframe[^>]+src="([^">]+)"/.exec(this._content.html)
    let src = ''

    if (matches && matches[1]) {
      src = matches[1]
    }

    this._content = {
      ...this._content,
      src
    }
  }
}

export default IframeModuleForm
